import React, { useState } from 'react'
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '../../../components/ui/carousel'

import slide1 from '../../../assets/images/carrossel/1.png'
import slide2 from '../../../assets/images/carrossel/2.png'
import slide3 from '../../../assets/images/carrossel/3.png'
import slide4 from '../../../assets/images/carrossel/4.png'
import slide5 from '../../../assets/images/carrossel/5.png'
import slide6 from '../../../assets/images/carrossel/6.png'
import slide7 from '../../../assets/images/carrossel/7.png'
import slide8 from '../../../assets/images/carrossel/8.png'
import slide9 from '../../../assets/images/carrossel/9.png'
import slide10 from '../../../assets/images/carrossel/10.png'

const slides = [
	slide1,
	slide2,
	slide3,
	slide4,
	slide5,
	slide6,
	slide7,
	slide8,
	slide9,
	slide10
]

export default function () {
	return (
		<section className="h-[30dvh] xl:h-[80dvh] bg-white">
			<Carousel>
				<CarouselContent>
					{slides.map(url => (
						<CarouselItem 
							key={url} 
							className="flex justify-center items-center select-none h-[30dvh] xl:h-[80dvh]"
						>
							<img src={url} alt="" className="size-full object-cover " />
						</CarouselItem>
					))}
				</CarouselContent>
				
				<CarouselPrevious className="left-8 top-1/2" />
				<CarouselNext className="right-8 top-1/2" />
			</Carousel>

			{/* <div className="container mx-auto flex flex-col md:flex-row items-center">
				<div className="md:w-1/2 mb-10 md:pr-10 flex flex-col">
					<img src={logo} alt="" className="h-24 mb-20 object-contain mb-8 self-center md:self-start" />

					<h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 lg:-mt-6 leading-tight animated fadeIn">
						Seus dados médicos sempre ao alcance
					</h1>

					<p className="text-lg text-gray-700 mb-8 animated fadeIn delay-200ms">
						O ZelAI é um aplicativo que dá acesso instantâneo aos seus
						dados clínicos durante um atendimento de emergência ou consulta médica.
					</p>

					<div className="flex gap-4 animated fadeIn delay-400ms">
						<a href="#planos" className="md:inline-flex px-8 py-4 md:px-4 md:py-2 bg-emerald-600 text-white rounded-md font-semibold border border-gray-300 hover:text-white hover:bg-emerald-700">
							Assine já
						</a>

						<a href="#beneficios" className="md:inline-flex px-8 py-4 md:px-4 md:py-2 rounded-md font-semibold border border-gray-300 text-slate-800">
							Saiba mais
						</a>
					</div>
				</div>

				<div className="w-screen sm:w-1/2 animated fadeIn delay-600ms relative h-[260px] md:h-[280px] lg:h-[420px]">
					<img
						src={ataquecardiaco}
						alt="ZelAI - Cartão médico com QR Code"
						className="animate-float-image-hero w-screen sm:w-full sm:max-w-lg mx-auto rounded-lg shadow-suave object-contain"
						style={{
							boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)'
						}}
					/>

					<CardFlip
						frente={frente}
						costa={costa}
					/>
				</div>
			</div> */}
		</section>
	)
}
